module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNvbG9yPXByaW1hcnksIFNpemU9UyI+CjxwYXRoIGlkPSJTaGFwZSIgZD0iTTE0IDEuOTk5ODZMMjEuNDggMTAuMDgyOU0yMS40OCAxMC4wODI5TDE0IDE4LjE2Nk0yMS40OCAxMC4wODI5TDIgMTAuMDgyOSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/graphapi-link-deep-dive.svg
// module id = K1Wq
// module chunks = 0